import React from 'react';
import { 
  Box,
  Container,
  Typography,
  Link,
  Grid,
  IconButton,
  useMediaQuery,
  Divider
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Social media icon styles
const SocialIcon = ({ children, href, label }) => (
  <IconButton 
    component="a"
    href={href}
    target="_blank"
    color="inherit"
    aria-label={label}
    sx={{ 
      fontSize: '1.5rem',
      transition: 'transform 0.3s ease',
      '&:hover': {
        transform: 'translateY(-3px)',
      }
    }}
  >
    {children}
  </IconButton>
);

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box 
      component="footer"
      sx={{
        bgcolor: theme.palette.secondary.main,
        color: '#ffffff',
        py: 4,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="space-between">
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}>
            <Box 
              component="img"
              src="https://freeweb3.infura-ipfs.io/ipfs/QmNpQiKm7oS5YWZgUVHbqXzU4wJFAWgPxojtiiaVXneNiJ"
              alt="Evidencer Logo"
              sx={{ 
                height: 60,
                mb: 1
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={4} sx={{ textAlign: isMobile ? 'center' : 'center' }}>
            <Typography variant="h6" gutterBottom>Quick Links</Typography>
            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 2, justifyContent: 'center' }}>
              <Link href="https://nav.evidencer.io/" color="inherit" underline="hover">
                Evidencer Forms
              </Link>
              <Link href="https://hero.evidencer.io/" color="inherit" underline="hover">
                Evidencer Hub
              </Link>
              <Link href="https://evidencer.io" color="inherit" underline="hover">
                Evidencer.io
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4} sx={{ textAlign: isMobile ? 'center' : 'right' }}>
            <Typography variant="h6" gutterBottom>Connect With Us</Typography>
            <Box sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-end' }}>
              <SocialIcon 
                href="https://www.linkedin.com/in/scott-stevenson-jd/"
                label="LinkedIn"
              >
                in
              </SocialIcon>
              <SocialIcon 
                href="https://github.com/lexautomatico"
                label="GitHub"
              >
                <span style={{ fontFamily: 'monospace' }}>&#x1F9EE;</span>
              </SocialIcon>
              <SocialIcon 
                href="https://x.com/tenfinney"
                label="Twitter"
              >
                𝕏
              </SocialIcon>
            </Box>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.2)' }} />
        
        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" sx={{ mb: isMobile ? 1 : 0 }}>
            ©2025 <span>Web3 Legal Engineering</span>. All Rights Reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link href="https://terms.freeweb3.com" color="inherit" underline="hover" variant="body2">
              Terms of Service
            </Link>
            <Link href="https://terms.freeweb3.com" color="inherit" underline="hover" variant="body2">
              Privacy Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;